import apiClient from "./apiClient";

export interface ServiceAccount {
  id: string;
  name: string;
  type: "service";
  isActive: boolean;
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface ServiceAccountCreateResponse {
  id: string;
  name: string;
  type: "service";
  apiKey: string;
  tenantId: string;
  createdAt: string;
}

export interface ServiceAccountListResponse {
  items: ServiceAccount[];
  total: number;
  limit: number;
}

/**
 * Create a new service account.
 * Returns the created account with a plaintext API key (shown only once).
 */
export const createServiceAccount = async (
  name: string
): Promise<ServiceAccountCreateResponse> => {
  const { data } = await apiClient.post("/admin/service-accounts", { name });
  return data;
};

/**
 * List all service accounts for the current tenant.
 * Does NOT include plaintext API keys.
 */
export const listServiceAccounts =
  async (): Promise<ServiceAccountListResponse> => {
    const { data } = await apiClient.get("/admin/service-accounts");
    return data;
  };

/**
 * Delete a service account by ID.
 */
export const deleteServiceAccount = async (id: string): Promise<void> => {
  await apiClient.delete(`/admin/service-accounts/${id}`);
};
